// API client for the Seasonal Performance Analyser.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/seasonal`;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

// `progress` is set while the account's first sync is still running.
export class ReportUnavailableError extends Error {
  constructor(message, progress = null) {
    super(message);
    this.reportUnavailable = true;
    this.progress = progress;
  }
}

export class NotConnectedError extends Error {
  constructor(message) { super(message); this.notConnected = true; }
}

const call = async (url, options = {}) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (res.status === 409 && data.error === 'report_unavailable') {
    throw new ReportUnavailableError(data.message, data.progress || null);
  }
  if (res.status === 400 && data.error === 'amazon_not_connected') {
    throw new NotConnectedError(data.message);
  }
  if (!res.ok) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
};

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') search.set(key, value);
  });
  const text = search.toString();
  return text ? `?${text}` : '';
};

// SF1 + SF2 — the pattern and its index, merged as the PRD directs.
export const getPattern = (token, { asin } = {}) =>
  call(`${BASE}/pattern${query({ asin })}`, { headers: authHeaders(token) });

// SF4 — what each festival and sale event adds on top of the pattern.
export const getEvents = (token, { asin } = {}) =>
  call(`${BASE}/events${query({ asin })}`, { headers: authHeaders(token) });

// SF3 — the peaks ahead, with the deadline to act on each.
export const getPeaks = (token, { asin, leadTimeDays, serviceLevel } = {}) =>
  call(`${BASE}/peaks${query({ asin, lead_time_days: leadTimeDays, service_level: serviceLevel })}`,
    { headers: authHeaders(token) });

// SF5 — the forecast as an order quantity per month.
export const getStockPlan = (token, { asin, leadTimeDays, serviceLevel } = {}) =>
  call(`${BASE}/stock-plan${query({ asin, lead_time_days: leadTimeDays, service_level: serviceLevel })}`,
    { headers: authHeaders(token) });

// The seller's lead time and stockout tolerance.
export const getInputs = (token) =>
  call(`${BASE}/inputs`, { headers: authHeaders(token) });

export const saveInputs = (token, body) =>
  call(`${BASE}/inputs`, {
    method: 'PUT', headers: authHeaders(token), body: JSON.stringify(body),
  });
